import { defineStore } from "pinia";
import { store } from "/@/store";

interface reportState {
  showReport?:boolean
}

export const useReportStore = defineStore({
  id:'app-reprot',
  state: (): reportState => ({
    showReport:false
  }),
  actions:{
    setShowReport(reportFlag?:boolean){
      this.showReport = reportFlag
    }
  }
})

export function useReportWithOut() {
  return useReportStore(store);
}

